module.exports = __webpack_public_path__ + "static/media/logo192.0e4047e2.png";